import Styled from 'styled-components'
import { ModulePerms } from '../../../access-control/domain/module'
import {
  ContactsOutlined,
  DotChartOutlined,
  FlagOutlined,
  ProfileOutlined,
  TeamOutlined,
  NodeIndexOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  MailOutlined,
  DollarOutlined,
  CodeSandboxOutlined,
  HistoryOutlined,
  StarOutlined,
  BarChartOutlined,
  FileOutlined,
  ContainerOutlined
} from '@ant-design/icons'
import Icons from '../../../../../Main/Components/Icons'
import { Layout, Menu } from 'antd'
import { useTranslation } from 'react-i18next'
import { Can } from '../../../access-control/infrastructure/roles-permissions/access-control'
import { useGate } from 'statsig-react'
import { SideMenuModule } from '../../domain/entities'
import { ShoppingBag } from '@phosphor-icons/react'
import { useAuth } from '../../../../../auth/Auth.hook'

const Logo = Styled.figure`
  text-align: center;
  padding: 5px;
  margin: 0;
  & > img {
    width: 55px;
    height: 55px;
    object-fit: contain;
  }
`

const { Sider } = Layout
const HAS_ROUTES = 'hasRoutes'
const HAS_ACCOUNTING = 'hasAccounting'

type SideMenuProps = {
  history: any
  view: string
  featureFlags: any
}
const SideMenu = ({ history, view, featureFlags }: SideMenuProps) => {
  const { t } = useTranslation()
  const isSegmenterMenuActive = useGate('segmenter_menu').value
  const isComandaMenuActive = useGate('comanda_menu').value
  const isSageMenuActive = useGate('is_sage_menu_active').value
  const isEcommerceMenuActive = useGate('is_ecommerce_menu_active').value
  const isWmsMenuActive = useGate('is_wms_menu_active').value
  const isActivityLogIsActive = useGate('is_activity_log_is_active').value
  const isMetabaseActive = useGate('is_metabase_active').value
  const isStarStreamActive = useGate('is_star_stream_active').value
  const { userInfo } = useAuth()

  const moduleMenu: SideMenuModule[] = [
    {
      key: 'orders',
      path: 'orders',
      icon: <ProfileOutlined />,
      label: 'menu.jobs-search',
      isAvailable: Can([ModulePerms.JOB])
    },
    {
      key: 'tasks',
      path: 'tasks',
      icon: <ContainerOutlined />,
      label: 'menu.tasks',
      isAvailable: Can([ModulePerms.TAS])
    },
    {
      key: 'alert-management',
      path: 'alert-management/orders',
      icon: <FlagOutlined />,
      label: 'menu.jobs-list',
      isAvailable: Can([ModulePerms.FLA])
    },
    {
      key: 'routes',
      path: 'routes',
      icon: <NodeIndexOutlined />,
      label: 'menu.routes',
      isAvailable: Can([ModulePerms.ROU]) && featureFlags[HAS_ROUTES] === 'true'
    },
    {
      key: 'metrics',
      path: 'metrics/order-status',
      icon: <DotChartOutlined />,
      label: 'metrics',
      isAvailable: Can([ModulePerms.MET])
    },
    {
      key: 'analytics',
      path: 'analytics',
      icon: <BarChartOutlined />,
      label: 'metabase.analytics',
      isAvailable: Can([ModulePerms.ANA]) && isMetabaseActive
    },
    {
      key: 'users',
      path: 'user-management/users',
      icon: <TeamOutlined />,
      label: 'menu.users',
      isAvailable: Can([ModulePerms.USE])
    },
    {
      key: 'resources',
      path: 'resources/stores',
      icon: <ContactsOutlined />,
      label: 'menu.resources',
      isAvailable: Can([ModulePerms.RES])
    },
    {
      key: 'system-parameters',
      path: 'system-parameters/general',
      icon: <SettingOutlined />,
      label: 'systemParameters',
      isAvailable: Can([ModulePerms.PAR])
    },
    {
      key: 'accounting',
      path: 'accounting',
      icon: <DollarOutlined />,
      label: 'Accounting',
      isAvailable: Can([ModulePerms.ACC]) && featureFlags[HAS_ACCOUNTING] === 'true'
    },
    {
      key: 'ecommerceAdmin',
      path: 'ecommerceAdmin',
      icon: <ShoppingCartOutlined />,
      label: 'E-commerce Admin',
      isAvailable: Can([ModulePerms.ECO]) && isEcommerceMenuActive
    },
    {
      key: 'wms',
      path: 'wms',
      icon: <CodeSandboxOutlined />,
      label: 'WMS',
      isAvailable: Can([ModulePerms.WMS]) && isWmsMenuActive
    },
    {
      key: 'segmenter',
      path: 'segmenter',
      icon: <MailOutlined />,
      label: 'Segmenter',
      isAvailable: Can([ModulePerms.SEG]) && isSegmenterMenuActive
    },
    {
      key: 'comanda',
      path: 'comanda',
      icon: <Icons iconName='TablePoint' />,
      label: 'Comanda',
      isAvailable: Can([ModulePerms.COM]) && isComandaMenuActive
    },
    {
      key: 'sage',
      path: 'order-ratings',
      icon: <StarOutlined />,
      label: 'order-ratings',
      isAvailable: Can([ModulePerms.ORA]) && isSageMenuActive
    },
    {
      key: 'jonahJameson',
      path: 'jonah-jameson',
      icon: <MailOutlined />,
      label: 'Jonah jameson',
      isAvailable: Can([ModulePerms.JJS])
    },
    {
      key: 'activity-log',
      path: 'activity-log',
      icon: <HistoryOutlined />,
      label: 'activityLog.activityLog',
      isAvailable: Can([ModulePerms.LOG]) && isActivityLogIsActive
    },
    {
      key: 'start-stream',
      path: 'reports',
      icon: <FileOutlined />,
      label: 'reports.title',
      isAvailable: Can([ModulePerms.SST]) && isStarStreamActive
    },
    {
      key: 'shopperWeb',
      path: 'shopperWeb',
      icon: <ShoppingBag />,
      label: 'picking-web',
      isAvailable: Can([ModulePerms.PIC])
    }
  ]
  const changeView = (viewToGo: string) => {
    if (viewToGo === 'shopperWeb') {
      window.open(process.env.REACT_APP_MFE_SHOPPER_WEB, '_blank')
    } else {
      history.push(`/${viewToGo}`)
    }
  }

  return userInfo ? (
    <Sider trigger={null} collapsible collapsed>
      <Menu theme='dark' mode='inline' defaultSelectedKeys={[view]}>
        <Logo>
          <img src={userInfo?.client?.logoUrl} alt='client-logo' />
        </Logo>
        {moduleMenu.map((module: SideMenuModule) => {
          if (module.isAvailable) {
            return (
              <Menu.Item
                key={module.key}
                onClick={() => {
                  changeView(module.path)
                }}
                icon={module.icon}
              >
                <span>{t(module.label)}</span>
              </Menu.Item>
            )
          }
          return null
        })}
      </Menu>
    </Sider>
  ) : null
}

export { SideMenu }
